const NAMESPACE = 'PARTNER_DETAILS';

const SET_PARTNER_DETAILS = `${NAMESPACE}/SET_PARTNER_DETAILS`;

export {
    SET_PARTNER_DETAILS,
};

export default NAMESPACE;
